import { useUserInfo } from '@/composition/useMember'

export function useRegion() {
  const nuxtApp = useNuxtApp()
  const { userInfo } = useUserInfo()

  const regionId = computed(
    () =>
      nuxtApp.$store.getters['region/region'].id ||
      nuxtApp.$store.getters['branch/branch'].region_id ||
      nuxtApp.$store.getters['product/productInfo'].region_id ||
      userInfo.value?.region_id
  )

  return {
    regionId,
  }
}
